import User from './models/User.js'
import {sortByTimestamp} from "../../helpers";

const state = {
    myId: undefined,
    amIModerator: false,
    users: [],
    historyFullLoaded: false,
}

const getters = {
    getMyId(state) {
        return state.myId
    },
    amIModerator(state) {
        return state.amIModerator
    },
    amIGuest(state) {
        return state.myId === 0
    },
    getUserById: (state) => (id) => {
        const user = state.users.find(user => user.uid === id)
        return user
    },
    getUsers(state) {
        return state.users
    },
    getHistoryIsFullLoaded(state) {
        return state.historyFullLoaded
    }
}

const mutations = {
    setMyId(state, id) {
        state.myId = id
    },
    makeMeModarator(state) {
        state.amIModerator = true
    },
    createUser(state, u) {
        let newUser = new User(u.uid, u.name, u.lastname, u.avatar)
        state.users.push(newUser)
    },
    updateUser(state, user) {
        let indexOfUser = state.users.findIndex(item => item.uid === user.uid)
        state.users.splice(indexOfUser, 1, user)
    },
    changeAvatar(state, {uid, image}) {
        const user = state.users.find(user => user.uid === uid)
        user.avatar = image
    },
    deleteUser(state, userId) {
        let index = state.users.findIndex(item => item.uid === userId)
        if (index > -1) {
            state.users.splice(index, 1)
        } else {
            // console.log('error while trying to delete user', userId)
        }
    },
    truncateUserList(state) {
        state.users = []
    },
    setHistoryIsFullLoaded(state, newState) {
        state.historyFullLoaded = newState
    }
}

const actions = {
    setMyId(context, id) {
        context.commit('setMyId', id)
    },
    makeMeModarator(context) {
        context.commit('makeMeModarator')
    },
    setUsers(context, users) {
        return new Promise((resolve) => {
            users.forEach(item => context.commit('createUser', item))
            resolve()
        })
    },
    createUser(context, user) {
        return new Promise((resolve) => {
            context.commit('createUser', user)
            resolve()
        })
    },
    updateUser(context, user) {
        context.commit('updateUser', user)
    },
    changeAvatar(context, {id, image}) {
        context.commit('changeAvatar', {id, image})
    },
    deleteUser(context, userId) {
        context.commit('deleteUser', userId)
    },
    truncateUserList(context) {
        return new Promise((resolve) => {
            context.commit('truncateUserList')
            resolve()
        })
    },
    handleGreetings(context, greetings) {
        // USERS SHOULD BE ON TOP
        if (greetings['users'] && greetings['users'].length)
            greetings["users"].forEach(user => context.commit('createUser', user))

        // QUOTES SHOULD BE BEFORE MESSAGES
        if (greetings['quotes'] && greetings['quotes'].length)
            greetings["quotes"].forEach(msg => context.dispatch('prepareMessage', msg))

        if (greetings['messages'] && greetings['messages'].length)
            greetings["messages"].sort(sortByTimestamp).forEach(msg => context.dispatch('prepareMessage', msg))

        if (greetings['questions'] && greetings['questions'].length)
            greetings["questions"].forEach(msg => context.dispatch('prepareMessage', msg))

        if (greetings['importants'] && greetings['importants'].length)
            greetings["importants"].forEach(msg => context.dispatch('prepareMessage', msg))
    },
    handleHistory(context, history) {
        const fullLoaded = (history['users'] == null || !history['users'].length)
            && (history['messages'] == null || !history['messages'].length)
        context.commit('setHistoryIsFullLoaded', fullLoaded)

        // USERS SHOULD BE ON TOP
        if (history['users'] && history['users'].length)
            history["users"].forEach(user => context.commit('createUser', user))

        // QUOTES SHOULD BE BEFORE MESSAGES
        if (history['quotes'] && history['quotes'].length)
            history["quotes"].forEach(msg => context.dispatch('prepareMessage', msg))

        if (history['messages'] && history['messages'].length)
            history["messages"].sort(sortByTimestamp).forEach(msg => context.dispatch('prepareMessage', msg))
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
